module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTP/JXf/HW//JXP/JX//IXP/HXP/JXP/HW//JXf/IXP/JXWlYu+UAAAALdFJOUwDAgKIZXe/fPJBw/UqUxwAAAL5JREFUKM9jYKAzYDUURAImUNHZu5HBtgawIMduVCAAFmVCE91AhOg2rKIVWEUDpLGIbmeIxiK6lcENi2gBjIEiqsDAkg1mbEYS3ebAwLAaIm8AF90YAGSxWCMUg0Q3QoKEZTpcMVB0cwMsVMNBorugog5QQRZ1iCOhJgRABNWQTQD6DCTMMQ3VNqCwAzxSDAj5YncKAysWH29iYCc6JHc3VGMTFSUhNolJD9hTFIM1auqDhh8rckIVnMJAdwAAMocx/Cj59nUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/benefitItemIcon.png
// module id = 1796
// module chunks = 0